import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import CustomerServices from "../../../services/OrderingServices/CustomerServices";
import CardPaymentService from "../../../services/OrderingServices/CardPaymentService";

const RechargeCardModal = ({
  isOpen,
  toggle,
  selectedCard,
  fetchCardAssign,
}) => {
  console.log("🚀 ~ selectedCardModal ~ selectedCard:", selectedCard);
  const formik = useFormik({
    initialValues: {
      cardUid: selectedCard?.cardUid || "",

      amount: 0,
      paymentMethod: 1,
      remarks: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      cardUid: Yup.string().required("Card UID is required"),
      amount: Yup.number().required("Amount is required"),
      paymentMethod: Yup.number().required("Payment Method is required"),
      remarks: Yup.string().required("Remarks is required"),
    }),
    onSubmit: async (values) => {
      try {
        const res = await CardPaymentService.recharge(values);

        toast.success("Recharge successfull");
        fetchCardAssign();
        toggle();
      } catch (error) {
        toast.error(error.message);
      }
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Recharge Card</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <FormGroup>
            <Label for="amount">Amount</Label>
            <Input
              id="amount"
              name="amount"
              type="text"
              {...formik.getFieldProps("amount")}
              invalid={formik.touched.amount && !!formik.errors.amount}
            />
            <FormFeedback>{formik.errors.amount}</FormFeedback>
          </FormGroup>

          <FormGroup>
            <Label for="remarks">Remarks</Label>
            <Input
              id="remarks"
              name="remarks"
              type="textarea"
              {...formik.getFieldProps("remarks")}
              invalid={formik.touched.remarks && !!formik.errors.remarks}
            />
            <FormFeedback>{formik.errors.remarks}</FormFeedback>
          </FormGroup>

          <ModalFooter>
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
            <Button color="primary" type="submit">
              Recharge Card
            </Button>
          </ModalFooter>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default RechargeCardModal;
